import { LINKEDIN_VISITOR_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function linkedinVisitorData(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case LINKEDIN_VISITOR_SUCCESS:
    
      // const parsedData = JSON.parse(action.payload.data)
      
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}